import { css } from '@emotion/core'

export default {
  chipsWrapper: css`
    margin-top: -8px;
  `,
  selectorWrapper: css`
    margin: 6px 0px;
  `,
}
